// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__k6hMN","logo":"Footer_logo__qDJde","textcolor":"Footer_textcolor__bevS+","social":"Footer_social__YHZD2"};